import { render, staticRenderFns } from "./learning-category-list.vue?vue&type=template&id=308a059e&scoped=true"
import script from "./learning-category-list.vue?vue&type=script&lang=ts"
export * from "./learning-category-list.vue?vue&type=script&lang=ts"
import style0 from "./learning-category-list.vue?vue&type=style&index=0&id=308a059e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a059e",
  null
  
)

export default component.exports